module.exports = __webpack_public_path__ + "img/img_bg2_lvsmaixueguan.43a476d8.png";